import axios from "axios";

export const LOGIN_URL = "admins/login";
export const ME_URL = "admins/me";
export const REFRESH_TOKEN_URL = "admins/refresh";
export const RESET_PASSWORD_URL = token => `admins/reset-password/${token}`;
export const CHECK_RESET_PASSWORD_URL = token => `admins/check-reset-password/${token}`;
export const VALIDATE_OTP_URL = "users/validate-otp";
export const REQUEST_OTP_URL = "users/otp-hook";

const authService = {
  login: (data) =>
    axios.post(LOGIN_URL, data),
  me: () =>
    axios.get(ME_URL),
  resetPassword: (data, token) =>
    axios.post(RESET_PASSWORD_URL(token), data),
  refreshToken: (refreshToken) =>
    axios.post(REFRESH_TOKEN_URL, { refreshToken }),
  checkResetPassword: (token) => axios.get(CHECK_RESET_PASSWORD_URL(token)),
  validateOtp: (data) =>
    axios.post(VALIDATE_OTP_URL, data),
  requestOtp: (data) =>
    axios.post(REQUEST_OTP_URL, data),
}

export default authService
